// Copyright (c) Bentley Systems
export class ConfirmationText {
  public cancel: string | undefined;
  public caption: string | undefined;
  public ok: string | undefined;
  public text: string | undefined;

  constructor(initializer?: any) {
    if (initializer) {
      if (initializer.cancel) {this.cancel = initializer.cancel;}
      if (initializer.caption) {this.caption = initializer.caption;}
      if (initializer.ok) {this.ok = initializer.ok;}
      if (initializer.text) {this.text = initializer.text;}
    }
  }
}
